module.exports = __webpack_public_path__ + "img/图片3.a7bfd51c.png";